import useScript from 'hooks/useScript';

const IPQS_LEARN_SRC =
  'https://ntsh.podium.com/api/podium.com/WssfE2yPPicLq76qYNr1Mm73l2LvGMNDHcyN84oL0ANFcYUtSDeChGqkfY1hj0ysZalgqOmyNqYVLUamtMIUBhNApG6u7EpmXnk74BZpNv6r7dWENR2IvCZtQ7LyQHNAsVE9hUIIEJVHZQwq94A5uDb1ZHciF1gRV4MsOrb2fjmikULm1EmyU95vJh5n4EQmrZIf36nN98XQwoIQ5AZpWo1lidlvhxWKta6Q8ZBCHVQCzHAx8jCzzlh9B8raAaFQ/learn.js';
const IPQS_INLINE_CODE =
  'window.ipqs="";var IPQ={Callback:function(){Startup.AfterResult((function(t){window.ipqs=t.request_id,window.ipqsResult=t})),Startup.Init()}}';

const useInitIpqs = (shouldLoad) => {
  const isProduction = process.env.NODE_ENV === 'production';
  const shouldLoadIpqs = shouldLoad && isProduction;

  useScript({
    crossorigin: 'anonymous',
    src: shouldLoadIpqs ? IPQS_LEARN_SRC : null,
  });
  useScript({ code: shouldLoadIpqs ? IPQS_INLINE_CODE : null });
};

export default useInitIpqs;
